import React from 'react';
import { Box, IconButton } from '@material-ui/core';
import { FiMoreVertical } from 'react-icons/fi';

import { IconContext } from 'react-icons';

const styles = {
  iconContainer: {
    width: 16,
    height: 16,
    cursor: 'pointer',
    textAlign: 'center',
    lineHeight: '18px',
    fontSize: 16,
  },
};

function EllipsisTrigger(props) {
  return (
    <IconButton {...props}>
      <Box h={1} justify="center" style={styles.iconContainer}>
        <IconContext.Provider value={{ size: 16 }}>
          <FiMoreVertical />
        </IconContext.Provider>
      </Box>
    </IconButton>
  );
}

export { EllipsisTrigger };
